import script from "./RoleMenuEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleMenuEditor.vue?vue&type=script&setup=true&lang=js"

import "./RoleMenuEditor.vue?vue&type=style&index=0&id=2d63db12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d63db12"]])

export default __exports__